import { ADMIN_URL } from '@/utils/constant'
import request from '@/utils/request'

export function getList(currentPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/getagreelist`,
    method: 'post',
    params: {
      page: currentPage,
      limit: pageSize,
      ...params
    }
  })
}
